import ConfirmDeleteTeachingPeriodModal from './ConfirmDeleteTeachingPeriodModal';
export default ConfirmDeleteTeachingPeriodModal;
